import { getAllOptionsByProfile, updateOptionsByProfile } from '../../../shared/data-services/manage-profile-service';
import { getProfile, getApplication, GetProfilesByApplicationId, GetApplicationByProfileId, updateProfilesByPosition, getAllProfilesByEmployeePosition, getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';

export async function getProfilesByEmployeePosition (companyId,employeePositionId){
    const data = await getAllProfilesByEmployeePosition(companyId,employeePositionId);
    return data || [ ];
};

export async function updateAllOptionsByProfile (options, employeePositionId){
  await updateOptionsByProfile(options, employeePositionId);
  return;
};

export async function getAllProfiles(companyId){
  const data = await getProfile(companyId);
  return data || [];
};

export async function getApplications (companyId){
  const data = await getApplication(companyId);
  return data || [ ];
};

export async function getProfilesByApplication (Id, companyId){
  const data = await GetProfilesByApplicationId(Id, companyId);
  return data || [ ];
};

export async function getApplicationByProfile (Id, companyId){
  const data = await GetApplicationByProfileId(Id, companyId);
  return data || [ ];
};

export async function updateAllProfilesByPosition (profiles, employeePositionId, employee){
  await updateProfilesByPosition(profiles, employeePositionId, employee);
  return;
};

  
